import { Footprints, Soup, Moon, ShieldCheck, Sparkles, Heart, CalendarHeart } from "lucide-react";

export const PC = {
  deep: "#1F5E3D", sage: "#6E9E7E", cream: "#FBF7F0", paper: "#FFFDF9", line: "#EAE2D5",
  ink: "#1F1B18", muted: "#6B5F55", coral: "#E8836B", gold: "#E0A93B", lavender: "#9B8FD6",
};

export const DIMS = [
  { id: "activity", label: "Movement & Activity", ask: "How does your pet like to move?", color: "#2F8F5B", icon: Footprints, anim: "pc-anim-stretch",
    why: "Daily movement keeps joints supple, weight in check and minds busy.",
    observe: "Notice whether walks or play feel easy, and if your pet still asks for them." },
  { id: "nutrition", label: "Nutrition & Hydration", ask: "What does mealtime look like?", color: "#E0A93B", icon: Soup, anim: "pc-anim-bob",
    why: "What and how your pet eats and drinks is one of the clearest everyday health signals.",
    observe: "Notice changes in appetite, how much water they drink, or how their waist looks." },
  { id: "comfort", label: "Sleep, Comfort & Mobility", ask: "How well does your pet rest and move?", color: "#9B8FD6", icon: Moon, anim: "pc-anim-breathe",
    why: "Good rest and comfortable movement help pets recover and enjoy their day.",
    observe: "Notice restlessness at night, stiffness after rest, or hesitation on stairs." },
  { id: "preventive", label: "Preventive Healthcare", ask: "How is everyday protection going?", color: "#3D7FA8", icon: ShieldCheck, anim: "pc-anim-pulse",
    why: "Vaccinations and parasite prevention protect against problems before they start.",
    observe: "Check when vaccinations and flea, tick or worm treatments were last given." },
  { id: "skin_dental", label: "Skin, Body & Dental Health", ask: "Anything you've noticed on skin, coat or teeth?", color: "#E8836B", icon: Sparkles, anim: "pc-anim-twinkle",
    why: "Skin, coat, teeth and body shape often show change before anything else does.",
    observe: "Notice scratching, bad breath, red gums, or new lumps when you stroke them." },
  { id: "behaviour", label: "Emotional Wellbeing", ask: "How does your pet seem in themselves?", color: "#D9799B", icon: Heart, anim: "pc-anim-beat",
    why: "A settled, curious pet is usually a comfortable one; sudden change can be a clue.",
    observe: "Notice hiding, new grumpiness, clinginess, or less interest in play or people." },
  { id: "lifestage", label: "Life Stage & Future Care", ask: "Looking ahead: check-ups and future care", color: "#1F5E3D", icon: CalendarHeart, anim: "pc-anim-sway",
    why: "Needs change from puppy or kitten to senior; regular vet reviews help you stay ahead.",
    observe: "Think about when your pet last had a routine check-up, not just a sick visit." },
];

export const STATUS = {
  good: { label: "Looking good", fg: "#2F8F5B", bg: "#E3F2E8" },
  improve: { label: "Worth reviewing", fg: "#B8791F", bg: "#FBF0DC" },
  vet: { label: "Discuss with your vet", fg: "#3D6FB0", bg: "#E3ECF8" },
  urgent: { label: "Discuss with your vet", fg: "#C8482A", bg: "#FBE3DC" },
  unknown: { label: "Not enough information", fg: "#8A7F75", bg: "#F0ECE6" },
};
